const defaultState = () => {
    return {
        appFlow: "",
        orgId: "",
        prospectId: "",
        companyName: "",
        homePageTailUrl: "",
        isCoPilot: false,
        coPilotEmail: '',
        appAssets: {},
        forgotPassDetails: {},
        setupPassword: true,
        loaderStatus: false,
        isNavigating: false,
        compLoaderStatus: false,
        appLanguage: "English",
        // Language picked before the borrower had a Prospect record. Flushed to
        // Salesforce by flushPendingAppLanguage() once sign-in/sign-up returns one.
        pendingAppLanguage: null,
        coPilotSession: false,
        createRINItems: false,
        // Steven changes starts - DMA co-brand: realtor Account id from #cobrand= and its details from Salesforce
        coBrandId: "",
        coBrand: {}
        // Steven changes ends
    }
}

const state = defaultState();

const getters = {
    getAppFlow: state => state.appFlow,
    getOrgId: state => state.orgId,
    getProspectId: state => state.prospectId,
    getCompanyName: state => state.companyName,
    getHomePageTailUrl: state => state.homePageTailUrl,
    getIsCoPilot: state => state.isCoPilot,
    getCoPilotEmail: state => state.coPilotEmail,
    getCoPilotSession: state => state.coPilotSession,
    getAssets: state => state.appAssets,
    getForgotPassDetails: state => state.forgotPassDetails,
    getSetupPassword: state => state.setupPassword,
    getLoaderStatus: state => state.loaderStatus,
    getIsnavigting: state => state.isNavigating,
    getCompLoaderStatus: state => state.compLoaderStatus,
    getAppLanguage: state => state.appLanguage,
    getPendingAppLanguage: state => state.pendingAppLanguage,
    getCreateRINItems: state => state.createRINItems,
    // Steven changes starts - DMA co-brand getters
    getCoBrandId: state => state.coBrandId,
    getCoBrand: state => state.coBrand || {},
    // Sign-up sends the realtor Account id only when Salesforce returned co-brand data,
    // i.e. the org has the co-brand code. Older orgs keep getting the LO/record id as before.
    getSignupUserId: state => (state.coBrandId && state.coBrand && state.coBrand.name) ? state.coBrandId : state.prospectId
    // Steven changes ends
};

const actions = {
    fetchAppFlow({ commit }, data) {
        commit('setAppFlow', data);
    },

    fetchOrgId({ commit }, data) {
        commit('setOrgId', data);
    },

    fetchProspectId({ commit }, data) {
        commit('setProspectId', data);
    },

    fetchCompanyName({ commit }, data) {
        commit('setCompanyName', data);
    },

    fetchHomePageTailUrl({ commit }, data) {
        commit('setHomePageTailUrl', data);
    },

    fetchIsCoPilot({ commit }, data) {
        commit('setIsCoPilot', data);
    },

    fetchCoPilotEmail({ commit }, data) {
        commit('setCoPilotEmail', data);
    },
    fetchCoPilotSession({ commit }, data) {
        commit('setCoPilotSession', data);
    },

    fetchAssets({ commit }, data) {
        commit('setAssets', data);
    },

    fetchForgotPassDetails({ commit }, data) {
        commit('setForgotPassDetails', data);
    },

    fetchSetupPassword({ commit }, data) {
        commit('setSetupPassword', data);
    },

    fetchLoaderStatus({ commit }, data) {
        commit('setLoaderStatus', data);
    },
    fetchIsNavigating({ commit }, data) {
        commit('setIsNavigating', data);
    },

    fetchCompLoaderStatus({ commit }, data) {
        commit('setCompLoaderStatus', data);
    },

    fetchAppLanguage({ commit }, data) {
        commit('setAppLanguage', data);
    },

    fetchPendingAppLanguage({ commit }, data) {
        commit('setPendingAppLanguage', data);
    },

    fetchCreateRINItems({ commit }, data) {
        commit('setCreateRINItems', data);
    },

    // Steven changes starts - DMA co-brand actions
    fetchCoBrandId({ commit }, data) {
        commit('setCoBrandId', data);
    },

    fetchCoBrand({ commit }, data) {
        commit('setCoBrand', data);
    },
    // Steven changes ends

    resetGlobalStore({ commit }) {
        commit('resetGlobalState')
    }
};

const mutations = {
    setAppFlow: (state, appflow) => state.appFlow = appflow,
    setOrgId: (state, orgid) => state.orgId = orgid,
    setProspectId: (state, prospectid) => state.prospectId = prospectid,
    setCompanyName: (state, company) => state.companyName = company,
    setHomePageTailUrl: (state, homePageTailUrl) => state.homePageTailUrl = homePageTailUrl,
    setIsCoPilot: (state, status) => state.isCoPilot = status,
    setCoPilotEmail: (state, email) => state.coPilotEmail = email,
    setCoPilotSession: (state, session) => state.coPilotSession = session,
    setAssets: (state, assets) => state.appAssets = assets,
    setForgotPassDetails: (state, details) => state.forgotPassDetails = details,
    setSetupPassword: (state, status) => state.setupPassword = status,
    setLoaderStatus: (state, loader) => state.loaderStatus = loader,
    setIsNavigating: (state, naviagteStatus) => state.isNavigating = naviagteStatus,
    setCompLoaderStatus: (state, comploader) => state.compLoaderStatus = comploader,
    setAppLanguage: (state, language) => state.appLanguage = language,
    setPendingAppLanguage: (state, language) => state.pendingAppLanguage = language,
    setCreateRINItems: (state, create_rin_items) => state.createRINItems = create_rin_items,
    // Steven changes starts - DMA co-brand mutations
    setCoBrandId: (state, id) => state.coBrandId = id,
    setCoBrand: (state, coBrand) => state.coBrand = coBrand,
    // Steven changes ends

    resetGlobalState(state) {
        Object.assign(state, defaultState())
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}